<template>
  <div class="prizes-wrapper w-100">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-content-center d-lg-none"
    >
      <img
        :src="require('@/assets/valo-prizes.png')"
        class="w-100 mb-2 mb-md-0 mr-md-2"
      />
      <img :src="require('@/assets/eafc-prizes.png')" class="w-100" />
    </div>
    <div
      class="valorant-prizes w-100 justify-content-end my-3 d-none d-lg-flex"
    >
      <div class="w-75">
        <div class="d-flex flex-column h-100 justify-content-around">
          <div class="prize-item-row text-right h-100">
            <div class="p-3">
              <h6 class="m-0 text-uppercase placement-item">1ère Place</h6>
              <h4 class="prize-amount m-0 text-uppercase">15.000 Dhs</h4>
            </div>
          </div>
          <div class="prize-item-row text-right h-100">
            <div class="p-3">
              <h6 class="m-0 text-uppercase placement-item">2ème Place</h6>
              <h4 class="prize-amount m-0 text-uppercase">10.000 Dhs</h4>
            </div>
          </div>
          <div class="prize-item-row text-right h-100">
            <div class="p-3">
              <h6 class="m-0 text-uppercase placement-item">3ème Place</h6>
              <h5 class="prize-amount m-0 text-uppercase">5.000 Dhs</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="eafc-prizes w-100 justify-content-end my-3 d-none d-lg-flex">
      <div class="w-75">
        <div class="d-flex flex-column h-100 justify-content-around">
          <div class="prize-item-row text-right h-100">
            <div class="p-3">
              <h6 class="m-0 text-uppercase placement-item">1ère Place</h6>
              <h4 class="prize-amount m-0 text-uppercase">15.000 Dhs</h4>
            </div>
          </div>
          <div class="prize-item-row text-right h-100">
            <div class="p-3">
              <h6 class="m-0 text-uppercase placement-item">2ème Place</h6>
              <h4 class="prize-amount m-0 text-uppercase">10.000 Dhs</h4>
            </div>
          </div>
          <div class="prize-item-row text-right h-100">
            <div class="p-3">
              <h6 class="m-0 text-uppercase placement-item">3ème Place</h6>
              <h5 class="prize-amount m-0 text-uppercase">5.000 Dhs</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrizesCards",
};
</script>

<style lang="css" scoped>
.prize-item-row {
  background: #fff;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.25) 35%,
    rgba(255, 255, 255, 0.25) 70%,
    rgba(255, 255, 255, 0) 100%
  );
}
.prize-item-row:nth-child(2) {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: transparent;
}
.valorant-prizes {
  background-image: url("@/assets/valo-prizes-bg.png");
  background-repeat: no-repeat;
  border-radius: 4px;
  min-height: 320px;
  background-size: 100% 100%;
}
.eafc-prizes {
  background-image: url("@/assets/ea-fc-prizes-bg.png");
  background-repeat: no-repeat;
  border-radius: 4px;
  min-height: 320px;
  background-size: 100% 100%;
}
.title-header:before {
  position: absolute;
  content: "";
  top: 10%;
  left: 10%;
  width: 340px;
  height: 340px;
  background-image: url("@/assets/trophy.png");
  background-repeat: no-repeat;
  background-size: 100%;
  z-index: -1;
}
.prize-amount {
  font-family: "race_sportregular", sans-serif;
  font-weight: 900;
  font-size: 36pt;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
.placement-item {
  font-family: "montserrat", sans-serif;
  font-style: italic;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 768px) {
  .prizes-wrapper:before {
    top: -10%;
    height: 85px;
  }
  .prizes-wrapper:after {
    bottom: -6%;
    height: 56px;
  }

  .prize-header img {
    height: 24px;
  }
  .omen-container {
    top: -60px;
  }
  .omen-container img {
    height: 280px;
  }
  .sage-container img {
    height: 280px;
  }
  .prize-card-title {
    font-size: 14pt;
  }
  .trip-timeline-header {
    width: fit-content;
    clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - 8px),
      calc(100% - 8px) 100%,
      0 100%
    );
  }
  .vct-container img {
    width: 100px;
    opacity: 0.8;
  }
  .trip-timeline-header h4 {
    font-size: 13pt;
  }
  .trip-timeline-desc p {
    font-size: 11pt;
  }

  .prize-amount {
    font-weight: 800;
    font-size: 36pt;
  }
  .title-header:before {
    top: 30%;
    left: 20%;
    width: 280px;
    height: 280px;
  }
  .prizes-wrapper {
    background-size:
      32px 32px,
      32px 32px,
      cover;
  }
}
@keyframes bounce {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(26px);
  }
}
</style>
